import { COMPOSITION_SKILL_BREAKDOWN_V3 } from '@revelio/data-access';

import { SKILL_TAXONOMY_SELECTION_LIST_KEYS } from '../../../../../../../shared/selection-lists/types';
import { FilterId } from '../../../../../filters/types/filters';
import { getEntKindForSkillLevelId } from '../../../../../filters/utils/role-skill-ent-kind';
import type { IcicleTaxonomy } from './types';

/**
 * The skill picker's level ids are positional (`skill_0` is the pinned
 * taxonomy's shallowest level, whatever number the API gives it), so the
 * ladder is only known once the tree is: until then no tier can be requested.
 */
export const skillIcicleTaxonomy: IcicleTaxonomy = {
  segment: 'skills',
  filterId: FilterId.CUSTOM_SKILL,
  overlapping: true,
  query: COMPOSITION_SKILL_BREAKDOWN_V3,
  breakdownLevelField: 'skill_breakdown_level',
  topNField: 'skill_top_n',
  tree: { kind: 'skill' },
  levelIds: (treeLevels) =>
    treeLevels.length === 0
      ? null
      : SKILL_TAXONOMY_SELECTION_LIST_KEYS.slice(0, treeLevels.length),
  entKind: getEntKindForSkillLevelId,
};
